import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f387f44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "w-column-primary" }
const _hoisted_3 = { class: "w-topbar-aux" }
const _hoisted_4 = { class: "tech-flex" }
const _hoisted_5 = { class: "content-calendar" }
const _hoisted_6 = { class: "content-button" }
const _hoisted_7 = { class: "content-status" }
const _hoisted_8 = { class: "mn-blue-element" }
const _hoisted_9 = { class: "w-column-aux" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-topbar-aux-2" }, "Per task", -1))
const _hoisted_11 = { class: "effort-item-date" }
const _hoisted_12 = { class: "effort-item-span" }

import { minuteCalc } from '@/logic/_infra/time'
import { computed, reactive } from 'vue';
import { endeavours as endeavours_get } from '@/controllers/workspaces/user.controller.workspace'
import { useAppContext } from '../_tech';
import { SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';
import EffortStatusComponent from '@/app/workspace/person/timeline/EffortStatusComponent.vue'
import { Sunrise, TimeSegment } from '@/logic/_infra/time';
import UserEdeavoursControl from '@/components/Workspaces/users/_spec/UserEdeavoursControl.vue'
import dayjs from 'dayjs';
import { OccupationtRef } from '@/logic/workspaces/tickets/_def';
import { singleOrNull, single } from '@/lib/array.lib'
import EffortTitleComponent from '@/app/workspace/persons/EffortTitleComponent.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'ReportsSubview',
  setup(__props) {

const model:
  {
    //sunrise: Sunrise | null;

    start: Date,
    end: Date,
    sunrises: SunriseReportRmodel[],
    occupations: { ref: OccupationtRef, efforts: { sunrise: Sunrise, minutes: number }[] }[]
    //efforts: SunriseReportRmodel[]


  } = reactive({ persons: [], sunrise: null, start: new Date(), end: new Date(), sunrises: [], efforts: [], occupations: [] })


const context = useAppContext();

const endeavours = endeavours_get(context)

const workspace = computed(() => context.cursor.workspace)

const endeavours_total = computed(() => {

  let buffer = 0

  model.sunrises.forEach(s => s.endeavours_Total.forEach(e => buffer = buffer + e.timespan_min))

  return buffer

})

function get(s: Date, e: Date) {

  model.sunrises.clear()

  const w = context.cursor.workspace

  const p = w?.user_person

  if (p != null) {



    w!.service.personEfforts_Period(p.nid, Sunrise.DateAsSunrise(s), Sunrise.DateAsSunrise(e)).then(reports => {

      model.sunrises.clear()

      model.occupations.clear()

      reports.forEach(r => {

        const report = new SunriseReportRmodel(p, TimeSegment.Instance(r.period))

        report.setup(context, r)

        model.sunrises.push(report)

        const occupatonions = report.summary.status.occupations(p.workspace)

        //const sunrise = report.sunrise

        occupatonions.forEach(o => {


          let buffer = singleOrNull(model.occupations, x => x.ref.equal(o.ref))

          if (buffer == null) {
            buffer = { ref: o.ref, efforts: [] }

            model.occupations.push(buffer)
          }

          buffer.efforts.push({ sunrise: report.sunrise, minutes: o.minutes })

        })


      })
    })
  }

}


return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(UserEdeavoursControl, {
          items: _unref(endeavours),
          class: "endeavours"
        }, null, 8, ["items"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, " Report: @" + _toDisplayString(workspace.value?.user_person?.name ?? 'n/a'), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_v_date_picker, {
              modelValue: model.start,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.start) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_date_picker, {
              modelValue: model.end,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.end) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (get(model.start, model.end)))
              }, "Get")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (workspace.value != null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, "Total: " + _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(endeavours_total.value)), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.sunrises, (s) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: s.period.toString()
                  }, [
                    _createElementVNode("strong", _hoisted_8, _toDisplayString(_unref(dayjs)(s.period.timepoint).format("MMM DD")), 1),
                    _createVNode(EffortStatusComponent, {
                      status: s.summary,
                      showOverlaps: false
                    }, null, 8, ["status"])
                  ], 64))
                }), 128))
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.occupations, (i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i.ref.jsonString()
          }, [
            _createVNode(EffortTitleComponent, {
              class: "mn-blue-element",
              effort: i.ref,
              active: false
            }, null, 8, ["effort"]),
            _createElementVNode("div", null, "Total: " + _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(i.efforts.reduce(function(a, b) { return a + b.minutes; }, 0))), 1),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.efforts, (e) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: e.sunrise.toString()
                }, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(dayjs)(e.sunrise.date()).format("MMM DD")) + " : ", 1),
                  _createTextVNode(),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(minuteCalc).toAproximatedHoursString(e.minutes)), 1)
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})